import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import ButtonSubmit from "../components/ButtonSubmit";
import InputUser from "../components/InputUser";
import ListItem from "../components/ListItem";
import "../components/Navbar/NavBar.css";
import NavBar  from '../components/Navbar/NavBar';
import classNames from 'classnames';
import FooterLoginRegister from '../components/FooterLoginRegister';
import { NavLink , useNavigate} from 'react-router-dom';
import { TokenContext } from '../components/Contexts/TokenContext';
import Toastify from 'toastify-js'
import { showMessage } from '../components/Functions';


export default function RegisterPage() {
  let navigate = useNavigate();
  const [typeInputPass,setTypeInputPass]= useState("password")
  const [typeInputConfirmPass,setTypeInputConfirmPass]= useState("password")
  const {setIsToken} = useContext(TokenContext)
    const [firstName,setFirstName] = useState()
    const [lastName,setLastName] = useState()
    const [email,setEmail] = useState()
    const [password,setPassword] = useState()
    const [confirmPassword,setConfirmPassword] = useState()
    const baseUrl = 'https://prohop-express.herokuapp.com/api/users/signup'
    const parms = {
      "firstName": firstName,
      "lastName": lastName,
      "email": email,
      "password": password,
      "passwordConfirmation": confirmPassword
    }
      useEffect(() =>{
        
      },[ButtonSubmit])
  
      const RegisterBtnClick = (e) =>{
        e.preventDefault()
        axios.post(baseUrl,parms)
        .then((response) =>{
          if(response.data.token){
            setIsToken(true)
            navigate("/home");
            localStorage.setItem("token",true)
            
            showMessage("New User Register successfully","#4cbc6a")
          }
        })
        .catch((error) =>{
          showMessage(error.response.data.message,"#ff3333")
        })
      } 
  return (
    <div className='flex flex-col gap-[52px] sm:gap-[2px] h-[100vh] bgAuth'>
      <NavBar />
      <form className='flex flex-col gap-5 container sm:w-9/12  mx-auto  w-9/12  md:w-7/12 lg:w-6/12 xl:w-5/12 my-14 '>
        <InputUser name ="First Name" icon="fa-solid fa-signature text-white mr-3" setValue={setFirstName} />
        <InputUser name ="Last Name" type="text" icon="fa fa-user text-white mr-3 " setValue={setLastName} />
        <InputUser name ="Email" type="email" icon="fa fa-user text-white mr-3 " setValue={setEmail} />
        <InputUser name ="Password" type={typeInputPass} icon="fa-solid fa-unlock text-white mr-3" value={password} setValue={setPassword} eyeIcon setTypeInput={setTypeInputPass}/>
        <InputUser name ="Confirm Password" type={typeInputConfirmPass}  icon="fa-solid fa-unlock text-white mr-3"  value={confirmPassword} setValue={setConfirmPassword} eyeIcon setTypeInput={setTypeInputConfirmPass} />
          <ButtonSubmit name="REGISTER" BtnClick={RegisterBtnClick}/>
          <span className='block text-center'>Already have an account? <NavLink to="/Login" className="text-[#4e3587]">Log in</NavLink>  </span>
      </form>
      <FooterLoginRegister classname="flex sm:ml-4 "/>
    </div>
  )
}
// wowyh@mailinator.com
// Pa$$w0rd!
